import type { AxiosInstance } from "axios";
import axios from "axios";
import { AxiosInterceptorAuthorization } from "../../../lib/client-api/interceptors/axios-interceptor-authorization/axios-interceptor-authorization";
import type { IAxiosInterceptorAuthorization } from "../../../lib/client-api/interceptors/axios-interceptor-authorization/axios-interceptor-authorization.interface";
import type { IAxiosConfigSingleton } from "./axios-config-singleton.interface";

const REQUEST_TIMEOUT_MS = 65_000;

export class AxiosConfigSingleton implements IAxiosConfigSingleton {
  static instance: AxiosConfigSingleton;
  private readonly _axiosInstance: AxiosInstance;

  constructor(
    private readonly _interceptorAuthorization: IAxiosInterceptorAuthorization = new AxiosInterceptorAuthorization()
  ) {
    this._axiosInstance = axios.create({
      withCredentials: true,
      timeout: REQUEST_TIMEOUT_MS,
    });

    const onFulfilled = this._interceptorAuthorization.onFulfilled.bind(this._interceptorAuthorization);
    const onRejected = this._interceptorAuthorization.onRejected.bind(this._interceptorAuthorization);

    this._axiosInstance.interceptors.response.use(onFulfilled, onRejected);
  }

  static getInstance(): AxiosConfigSingleton {
    if (!AxiosConfigSingleton.instance) {
      AxiosConfigSingleton.instance = new AxiosConfigSingleton();
    }

    const instance = AxiosConfigSingleton.instance;
    return instance;
  }

  public getSingletonClient(): AxiosInstance {
    return this._axiosInstance;
  }

  static getClient(): AxiosInstance {
    const instance = AxiosConfigSingleton.getInstance();
    const client = instance.getSingletonClient();
    return client;
  }
}
